import React from 'react';
import { useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { oidcSelector } from '../selectors/oidcSelectors';

import AppRoute from './app-route';

const AuthenticationRoute = (props) => {
  const oidc = useSelector(oidcSelector);
  console.log(oidc.isLoadingUser)
  console.log(oidc.user)

  return (
    <React.Fragment>
      {!oidc.isLoadingUser && oidc.user && <AppRoute {...props} />}
      {!oidc.isLoadingUser && !oidc.user && <Redirect to="/login" />}
    </React.Fragment>
  );
};
export default AuthenticationRoute;


// WEBPACK FOOTER //
// ./src/routes/authentication-route.js